import { fetchSameOrigin } from '../Utils';

function reactivateAccount(memberId) {
  return fetchSameOrigin(`/members/${memberId}/reactivate`, 'PUT')
    .then(resp => resp.json()
    .then(_ => new Promise((resolve) => {
      window.location.reload()
      resolve();
    })
  ));
}

export default reactivateAccount;
